import { supabase } from '../../supabase';

export const fetchAskerCategoriesTheme = (fileName: string) => {
  return supabase.storage.from('dev').getPublicUrl(`asker-categories-themes/${fileName}`);
};

export const uploadAskerCategoriesTheme = (fileName: string, file: File) => {
  return supabase.storage.from('dev').upload(`asker-categories-themes/${fileName}`, file);
};
